import PageHeader from "@/components/site/PageHeader";
import { NewHere } from "@/components/site/Forms";
import { ServiceTimes, NextSteps } from "@/components/site/Sections";
import { usePageMeta } from "@/lib/usePageMeta";

export default function NewHerePage() {
  usePageMeta(
    "New Here? Plan Your Visit",
    "First time at RE//FORM PLACE CHI? Let us know you're coming — we'll save you a seat, greet you at the door, and help you find your place.",
  );
  return (
    <div data-testid="new-here-page">
      <PageHeader
        crumb="Plan Your Visit"
        eyebrow="New Here"
        title="Plan Your"
        accent="Visit"
        intro="Come as you are. Tell us you're coming and our hospitality team will be ready to welcome you."
        image="/outreach/reform-shirts-women.webp"
        imagePosition="center 30%"
      />
      <NewHere />
      <ServiceTimes />
      <NextSteps />
    </div>
  );
}
